import { NavLink, ThemeIcon } from '@mantine/core';
import { IconArchive } from '@tabler/icons';
import { AppRoutePaths } from '../../../utils/enums';

interface ProductsLinkProps {
  navigate(to: string): void;
  themeColor: 'dark' | 'light';
}

export function ProductsLink({ navigate, themeColor }: ProductsLinkProps) {
  return (
    <NavLink
      styles={{
        label: {
          color: themeColor === 'light' ? '#373A40' : '#FBFBFB',
        },
      }}
      label="Produtos"
      fw="bold"
      color=""
      icon={
        <ThemeIcon color="orange" variant="light">
          <IconArchive size={16} />
        </ThemeIcon>
      }
      childrenOffset={28}
    >
      <NavLink
        label="XBZ"
        onClick={() => navigate(AppRoutePaths.PRODUCTS_XBZ)}
      />
    </NavLink>
  );
}
